import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import querystring from 'querystring';
import { StateType } from '../../../../../state/state.types';
import makeQueryParamsUtil from '../../../../../../../shared/makeQueryParamsUtil';
import { getQueryParamsFromState } from '../../../../state/utils';
import {
  search,
  addRestrictionToLawArticleId,
  removeRestrictionToLawArticleId,
} from '../../../../state/actions';

const mapState = ({ queryParams, results }: StateType) => {
  let searchQueryUrl = querystring.stringify(
    makeQueryParamsUtil(
      getQueryParamsFromState({ ...queryParams, userQuery: results.query }),
    ),
  );
  searchQueryUrl += `&original_query_key=${queryParams.originalQueryKey}`;

  return {
    searchQueryUrl,
    restrictToLawArticleIds: queryParams.restrictToLawArticleIds,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onFilterOnArticle(articleId: string, toRestrict: boolean) {
    dispatch(
      toRestrict
        ? addRestrictionToLawArticleId(articleId)
        : removeRestrictionToLawArticleId(articleId),
    );
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
